/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLineReconnaissance = ({ acte }: Props) => {
  let pere = '';
  if (acte.nomClassementPere) {
    pere = `le ${_date.short(acte.dateReconnaissancePere ?? '')} par ${trimComma(acte.nomClassementPere)}`;
  }

  let mere = '';
  if (acte.nomClassementMere) {
    mere = `le ${_date.short(acte.dateReconnaissanceMere ?? '')} par ${trimComma(acte.nomClassementMere)}`;
  }

  return (
    <>
      <Table.Cell content={trimComma(acte.nomClassementEnfant)} />
      <Table.Cell content={pere} />
      <Table.Cell content={mere} />
    </>
  );
};

export default ActeTableLineReconnaissance;
